import { getHttpClient } from 'src/http-client';

const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

export interface CheckProjectAuthorizationServiceInputType {
  organizationName: string;
}

export type CheckProjectAuthorizationServiceOutputType = {
	type: 'error';
} | {
	type: 'success';
	data: {
		userAuthorization: boolean;
		servicePrincipalAuthorization: boolean;
	}
}

export async function checkProjectAuthorizationService(input: CheckProjectAuthorizationServiceInputType): Promise<CheckProjectAuthorizationServiceOutputType> {
	try {
		const httpClient = getHttpClient();
		const response = await httpClient.get(`${apiUrl}/auth/find-organization-authorization/${input.organizationName}`);
		return {
			type: 'success',
			data: response.data,
		};
	} catch (error) {
		return {
			type: 'error',
		};
	}
}